<template>
  <div class="page">
        <!-- 搜索 -->
  <el-form v-if="isSearch" :model="queryForm" ref="form" label-width="80px" :inline="true" size="small" class="query-form" @submit.native.prevent>
              <el-form-item label="名称">
                  <el-input  v-model="queryForm.additionName"></el-input>
              </el-form-item>
              <el-form-item>
                  <el-button size="small" type="primary" icon="el-icon-search" @click="getWashServiceAdditionList">查询</el-button>
                  <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
              </el-form-item>
  </el-form>
  <div class="page-content">
    <div class="page-tool-bar">
      <div class="el-btn-group">
        <el-button
          type="primary"
          size="small"
          icon="el-icon-plus"
          @click="addWashServiceAddition"
        >新建</el-button>
        <el-button
          type="warning"
          plain
          size="small"
          icon="el-icon-edit"
          :disabled="multipleSelection.length != 1"
          @click="editWashServiceAddition(null)"
        >修改</el-button>
        <el-button
          type="danger"
          plain
          size="small"
          icon="el-icon-delete"
          :disabled="multipleSelection.length <= 0"
          @click="deleteWashServiceAddition(null)"
        >删除</el-button>
      </div>

      <div class="icon-group">
            <el-upload v-if="this.isImportDate"
              class="upload-demo"
              action="#"
                            :http-request="upload"
              :show-file-list="true">
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">只允许导入“xls”或“xlsx”格式文件！</div>
            </el-upload>
        <span
          title="搜索"
          class="icon-box"
          @click="search"
        >
          <Icon color="#606266">
            <Search />
          </Icon>
        </span>
        <span
          class="icon-box"
          @click="refreshWashServiceAdditionList"
        >
          <Icon color="#606266">
            <Refresh />
          </Icon>
        </span>
      </div>
    </div>
          <!-- 列表数据 -->
    <el-table
      :data="washServiceAdditionList"
      row-key="id"
      border
      height="100%"
      :header-row-style="{height: '10px'}"
      :header-cell-style="{padding: '10px'}"
      :row-style="{height: '9px'}"
      :cell-style="{padding: '9px'}"
      @selection-change="handleSelectionChange"
      size="small"
    >
      <el-table-column
        align="center"
        type="selection"
        width="60"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="additionName"
        label="名称"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="fee"
        label="费用"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="sort"
        label="排序"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="createTime"
        label="创建时间"
      > </el-table-column>
      <el-table-column
        fixed="right"
        align="center"
        label="操作"
        width="300"
      >
        <template slot-scope="scop">
          <div class="operation">
            <div @click="checkWashServiceAddition(scop.row.id)">
              <Icon size="16">
                <Eye24Regular />
              </Icon>
              <span class="operation-label">查看</span>
            </div>
            <div @click="editWashServiceAddition(scop.row.id)">
              <Icon size="16">
                <Edit24Regular />
              </Icon>
              <span class="operation-label">修改</span>
            </div>
            <div @click="deleteWashServiceAddition(scop.row.id)">
              <Icon size="16" style="color: red">
                <Delete24Regular />
              </Icon>
              <span class="operation-label" style="color: red">删除</span>
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-box">
      <el-pagination
        @size-change="sizeChange"
        @current-change="currentChange"
        :current-page.sync="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalNum"
        background
        :pager-count="7"
      >
      </el-pagination>
    </div>
    <!-- 新增/查看/修改信息 -->
    <el-dialog
      :title="washServiceAdditionStates[washServiceAdditionState]"
      :visible.sync="showDialog"
      width="60%"
      @close="closeDialog"
    >
      <div>
        <el-form
          :model="washServiceAddition"
          ref="washServiceAdditionForm"
          :rules="rules"
          label-width="120px"
          :inline="true"
          size="small"
        >
          <el-form-item
            label="名称"
            prop="additionName"
          >
            <el-input
              size="small"
              v-model="washServiceAddition.additionName"
              :disabled="washServiceAdditionState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="费用"
            prop="fee"
          >
            <el-input
              size="small"
              v-model="washServiceAddition.fee"
              :disabled="washServiceAdditionState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="排序"
            prop="sort"
          >
            <el-input
              size="small"
              v-model="washServiceAddition.sort"
              :disabled="washServiceAdditionState == 'check'"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>

      <div
        slot="footer"
        class="flex justify-end"
      >
        <el-button @click="closeDialog">关闭</el-button>
        <el-button
          type="primary"
          @click="submitForm"
          v-if="washServiceAdditionState != 'check'"
        >确定</el-button>
      </div>
    </el-dialog>
  </div>
  </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun } from '@/utils/request.js';

export default {
    components: {
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search
    },
        watch: {
            checkState(val) {
                if (val == 'check') {
                    this.resetWashServiceAdditionList();
                    this.getWashServiceAdditionList(this.queryForm);
                    this.$emit('resetCheckState');
                } else if (val == 'reset') {
                    this.resetWashServiceAdditionList();
                    this.getWashServiceAdditionList();
                    this.$emit('resetCheckState');
                }
            }
        },
    data() {
            return {
                queryForm:{
                     additionName: '', //名称
                     fee: '', //费用
                     sort: '', //排序
                },
                loading: false,
                showDialog: false,
                isImportDate: false,
                isSearch: false,
                pageSize: 10,
                currentPage: 1,
                totalNum: 0,
                currentUserId: '',
                washServiceAdditionState: 'add',
                washServiceAdditionStates: {
                    add: '新建附加项目',
                    check: '查看附加项目',
                    edit: '修改附加项目'
                },

                multipleSelection: [],
                washServiceAdditionList: [],
                washServiceAddition: {
                    id: '', //ID
                    additionName: '', //名称
                    fee: '', //费用
                    sort: '', //排序
                    createTime: '', //创建时间
                },
                btnLoading: false,

                rules: {
                    id: [{ required: true, message: 'ID不能为空', trigger: 'blur' }],
                    additionName: [{ required: true, message: '名称不能为空', trigger: 'blur' }],
                    fee: [{ required: true, message: '费用不能为空', trigger: 'blur' }],
                    sort: [{ required: true, message: '排序不能为空', trigger: 'blur' }],
                }
            };
        },
        created() {
            this.getWashServiceAdditionList();
        },
        methods: {
            search(){
                this.isSearch = !this.isSearch;
            },
            resetWashServiceAdditionList() {
                this.pageSize = 10;
                this.currentPage = 1;
                this.washServiceAdditionList = [];
            },
            resetDialog() {
                this.washServiceAdditionState = 'add';
                this.showDialog = false;
                this.queryForm = {
                      additionName: '', //名称
                      fee: '', //费用
                      sort: '', //排序
                };
                this.getWashServiceAdditionList();
            },
            closeDialog() {
                this.showDialog = false
                this.washServiceAddition = {
                      id: '', //ID
                      additionName: '', //名称
                      fee: '', //费用
                      sort: '', //排序
                      createTime: '', //创建时间
                };
            },
            submitForm() {
                if (this.washServiceAdditionState == 'add') {
                    this.$refs.washServiceAdditionForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/wash/serviceaddition/add`,{ ...this.washServiceAddition }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000,
                                    });
                                    this.resetWashServiceAdditionList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                } else if (this.washServiceAdditionState == 'edit') {
                    this.$refs.washServiceAdditionForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/wash/serviceaddition/edit`,{ ...this.washServiceAddition }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000
                                    });
                                    this.resetWashServiceAdditionList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                }
            },
            addWashServiceAddition() {
                this.showDialog = true;
                this.washServiceAdditionState = 'add';
            },
            checkWashServiceAddition(washServiceAdditionId) {
                console.log(washServiceAdditionId);
                this.currentWashServiceAdditionId = washServiceAdditionId;

                this.getWashServiceAdditionById();
                this.showDialog = true;
                this.washServiceAdditionState = 'check';
            },
            editWashServiceAddition(washServiceAdditionId) {
                console.log('washServiceAddition', washServiceAdditionId);
                if (washServiceAdditionId) {
                    this.currentWashServiceAdditionId = washServiceAdditionId;
                    this.getWashServiceAdditionById();
                } else {
                    this.washServiceAddition = { ...this.washServiceAddition, ...this.multipleSelection[0] };
                }

                this.showDialog = true;
                this.washServiceAdditionState = 'edit';
            },
            deleteWashServiceAddition(washServiceAdditionId) {
                let ids = '';
                if (washServiceAdditionId) {
                    ids = washServiceAdditionId;
                } else {
                    ids = this.multipleSelection.map((washServiceAddition) => washServiceAddition.id).join(',');
                }
                console.log({ ids });
                this.$confirm('确定删除所选项吗？', '提示', {
                    type: 'warning'
                })
                    .then(() => {
                        deleteFun(`/wash/serviceaddition/delete`,{ ids }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetWashServiceAdditionList();
                                this.getWashServiceAdditionList();
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                            }
                        });
                    })
                    .catch(() => {});
            },
            refreshWashServiceAdditionList() {
                this.resetWashServiceAdditionList();
                this.getWashServiceAdditionList();
            },
            getWashServiceAdditionList(query = {}) {
                this.loading = true;
                get(`/wash/serviceaddition/findList`,{  ...this.queryForm, pageNum: this.currentPage, pageSize: this.pageSize }).then((res) => {
                    this.loading = false;
                    if (res.success) {
                        this.washServiceAdditionList = res.page.list;
                        this.totalNum = res.page.total;
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            getWashServiceAdditionById() {
                get(`/wash/serviceaddition/get`,{ id: this.currentWashServiceAdditionId }).then((res) =>{
                    if(res.success){
                      this.washServiceAddition = { ...this.washServiceAddition, ...res.washServiceAddition };
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            /**
             * 导出信息
             */
            exportWashServiceAdditionList() {
                //this.btnLoading = true;
                exprotExcel(`/wash/serviceaddition/export`, {...this.queryForm});
            },
            /**
             * 导出模板
             */
            importTemplate() {
                this.btnLoading = true;
                importTemplate(`/wash/serviceaddition/importTemplate`, this.btnLoading);
            },
            /**
             * 导入数据
             */
            isImport() {
                this.isImportDate = !this.isImportDate;
            },
            upload(params){
              const file = params.file;
              const formData = new FormData();
              formData.append('file', file);
              console.log({ formData });
              importDate(`/wash/serviceaddition/importData`,formData);
              this.refreshWashServiceAdditionList();
            },
            handleSelectionChange(value) {
                console.log(value);
                this.multipleSelection = value;
            },
            currentChange(page) {
                this.currentPage = page;
                this.getWashServiceAdditionList();
            },
            sizeChange(size) {
                this.pageSize = size;
                this.getWashServiceAdditionList();
            }
        }

};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
    border-bottom: 1px solid #eee;
}
.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
</style>